<app-change-course-header
  [heading]="'Admin: Course Management: Practice Test : List'"
  [showChangeCourse]="true"
  (addMockExam)="AddEditExam()"
></app-change-course-header>

<div class="row mt-3 mb-2">
  <div class="col-md-2 col-sm-6">
    <label class="form-label fw-semibold mb-1" for="availableDateFilter">Available Date</label>
    <div class="d-flex gap-2">
      <input
        id="availableDateFilter"
        type="date"
        class="form-control form-control-sm"
        [ngModel]="availableDateFilter"
        (ngModelChange)="onAvailableDateFilterChange($event)"
      />
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        (click)="clearAvailableDateFilter()"
        [disabled]="!availableDateFilter"
      >
        Clear
      </button>
    </div>
  </div>
</div>

<div class="row mt-4">
  <div class="table-responsive px-0">
    <table class="table table-bordered" #table1>
      <thead class="table-light">
        <tr>
          <th
            sortable="Course_Test_Id"
            (sort)="onSort($event)"
            rowspan="2"
            style="
              vertical-align: middle;
              text-align: center;
              width: 5%;
              white-space: normal;
            "
          >
            Course Test ID
            <i
              *ngIf="sortColumn === 'Course_Test_Id'"
              class="ms-1 fa"
              [class.fa-sort-asc]="sortDirection === 'asc'"
              [class.fa-sort-desc]="sortDirection === 'desc'"
              [class.mt-2]="sortDirection === 'desc'"
            ></i>
          </th>
          <th
            sortable="Practice_Test_Name"
            (sort)="onSort($event)"
            rowspan="2"
            style="
              vertical-align: middle;
              text-align: center;
              width: 15%;
              white-space: normal;
            "
          >
            Test Name
            <i
              *ngIf="sortColumn === 'Practice_Test_Name'"
              class="ms-1 fa"
              [class.fa-sort-asc]="sortDirection === 'asc'"
              [class.fa-sort-desc]="sortDirection === 'desc'"
              [class.mt-2]="sortDirection === 'desc'"
            ></i>
          </th>
          <th
            sortable="Number_Of_Questions"
            (sort)="onSort($event)"
            rowspan="2"
            style="
              vertical-align: middle;
              text-align: center;
              width: 5%;
              white-space: normal;
            "
          >
            # of Questions
            <i
              *ngIf="sortColumn === 'Number_Of_Questions'"
              class="ms-1 fa"
              [class.fa-sort-asc]="sortDirection === 'asc'"
              [class.fa-sort-desc]="sortDirection === 'desc'"
              [class.mt-2]="sortDirection === 'desc'"
            ></i>
          </th>
          <th
            rowspan="2"
            sortable="Practice_Test_Sequence_Number"
            (sort)="onSort($event)"
            style="
              vertical-align: middle;
              text-align: center;
              width: 5%;
              white-space: normal;
            "
          >
            Test Number
            <i
              *ngIf="sortColumn === 'Practice_Test_Sequence_Number'"
              class="ms-1 fa"
              [class.fa-sort-asc]="sortDirection === 'asc'"
              [class.fa-sort-desc]="sortDirection === 'desc'"
              [class.mt-2]="sortDirection === 'desc'"
            ></i>
          </th>
          <th
            rowspan="2"
            sortable="Total_Score"
            (sort)="onSort($event)"
            style="vertical-align: middle; text-align: center; width: 2%"
          >
            Total Score
            <i
              *ngIf="sortColumn === 'Total_Score'"
              class="ms-1 fa"
              [class.fa-sort-asc]="sortDirection === 'asc'"
              [class.fa-sort-desc]="sortDirection === 'desc'"
              [class.mt-2]="sortDirection === 'desc'"
            ></i>
          </th>
          <th
            rowspan="2"
            sortable="Test_Type_Name"
            (sort)="onSort($event)"
            style="vertical-align: middle; text-align: center; width: 6%"
          >
            Test Type
            <i
              *ngIf="sortColumn === 'Test_Type_Name'"
              class="ms-1 fa"
              [class.fa-sort-asc]="sortDirection === 'asc'"
              [class.fa-sort-desc]="sortDirection === 'desc'"
              [class.mt-2]="sortDirection === 'desc'"
            ></i>
          </th>
          <th
            rowspan="2"
            sortable="Practice_Test_Status_Type_Code"
            (sort)="onSort($event)"
            style="vertical-align: middle; text-align: center; width: 5%"
          >
            Status
            <i
              *ngIf="sortColumn === 'Practice_Test_Status_Type_Code'"
              class="ms-1 fa"
              [class.fa-sort-asc]="sortDirection === 'asc'"
              [class.fa-sort-desc]="sortDirection === 'desc'"
              [class.mt-2]="sortDirection === 'desc'"
            ></i>
          </th>

          <th
            rowspan="2"
            sortable="Available_Date"
            (sort)="onSort($event)"
            class="audit-info-col"
            style="vertical-align: middle; text-align: center"
          >
            Available Date
            <i
              *ngIf="sortColumn === 'Available_Date'"
              class="ms-1 fa"
              [class.fa-sort-asc]="sortDirection === 'asc'"
              [class.fa-sort-desc]="sortDirection === 'desc'"
              [class.mt-2]="sortDirection === 'desc'"
            ></i>
          </th>
          <th
            [attr.colspan]="courses && courses.length > 0 ? courses.length : 1"
            style="text-align: center; width: 40%"
          >
            Applicable Course Plan
          </th>
          <th
            rowspan="2"
            style="
              vertical-align: middle;
              text-align: center;
              width: 30px;
              min-width: 24px;
              max-width: 36px;
              white-space: nowrap;
              overflow: hidden;
              padding: 0;
            "
          >
            <!-- for icon or checkbox -->
          </th>
        </tr>
        <tr>
          <th
            *ngFor="let item of courses"
            sortable="{{ item.Description }}"
            class="small-th"
          >
            {{ getPlanNameInitails(item.Description) }}
            <!--
            <i *ngIf="sortColumn === item.Description"
               class="ms-1 fa"
               [class.fa-sort-asc]="sortDirection === 'asc'"
               [class.fa-sort-desc]="sortDirection === 'desc'"
               [class.mt-2]="sortDirection === 'desc'"></i>
            -->
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="let item of weeklyPracticeTest"
          (click)="setSelectedExamId(item.Course_Test_Id)"
          [class.table-primary]="item.Course_Test_Id === selectedRowId"
        >
          <td>{{ item.Course_Test_Id }}</td>
          <td>{{ item.Practice_Test_Name }}</td>
          <td>{{ item.Number_Of_Questions }}</td>
          <td>{{ item.Practice_Test_Sequence_Number }}</td>
          <td>{{ item.Total_Score }}</td>
          <td>{{ item.Test_Type_Name || "-" }}</td>
          <td>{{ item.Practice_Test_Status_Type_Code }}</td>
          <td>
            <div
              class="d-flex flex-wrap align-items-center justify-content-center gap-1"
            >
              {{
                item.Available_Date
                  ? (item.Available_Date | date: "mediumDate")
                  : "-"
              }}
            </div>
          </td>
          <td *ngFor="let course of courses">
            <input
              disabled
              class="form-check-input"
              type="checkbox"
              [checked]="checkedCoursePlan(course.Code, item.Course_Test_Id)"
            />
          </td>
          <td>
            <div class="d-flex gap-2 justify-content-center">
              <i
                class="fa fa-edit pointer-cursor"
                title="Edit Practice Test"
                (click)="AddEditExam(item)"
              ></i>
              <i
                class="fa fa-link pointer-cursor"
                title="Practice Test Questions"
                (click)="navigateToPracticeTestQuestions(item)"
                aria-hidden="true"
              >
              </i>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
